import { inject, Pipe, type PipeTransform } from '@angular/core';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { Channel, computeChannelName } from '@pixacare/chat';

@Pipe({
  name: 'channelName',
  standalone: true,
})
export class ChannelNamePipe implements PipeTransform {
  private readonly authenticationService = inject(AuthenticationService);

  transform(channel: Channel): string {
    return computeChannelName(channel, this.authenticationService.user.id);
  }
}
